import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { WishlistEntry } from '@wishlist/const';
import { WishlistService } from '@wishlist/feature';
import { filter, Observable, take } from 'rxjs';

@Component({
  selector: 'sd-wishlist-content',
  templateUrl: './wishlist-content.component.html',
  styleUrls: ['./wishlist-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WishlistContentComponent implements OnInit {
  private readonly wishlistService = inject(WishlistService);

  entries$: Observable<WishlistEntry[]>;
  loading$: Observable<boolean>;
  error$: Observable<boolean>;

  ngOnInit(): void {
    this.entries$ = this.wishlistService.getEntries().pipe(
      filter((entries) => entries.length > 0),
      // Нам нужно сохранять только последнее состояние.
      // Если товар находится в избранном, то сердечко на странице избранного желтое,
      // клиент, чтобы убрать товар из избранного повторно кликает на сердечко,
      // при этом со страницы избранного товар пропадает только после обновления или ухода со страницы.
      take(1),
    );

    this.loading$ = this.wishlistService.getEntriesLoading();
    this.error$ = this.wishlistService.getEntriesError();
  }
}
